// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"2ad0461a","209":"df68fc55","829":"bc4278a0","878":"53508adb"}[chunkId] + ".chunk.js";
};